import { useCallback } from 'react';

import { useUpdateChatNotificationPreferencesDataMutationMutation } from '../../../generated';

export interface UseUpdateChatNotificationPreferencesConfig {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export interface UpdateChatNotificationPreferencesInput {
  chatId: string;
  supplierId: string;
  isEnabled: boolean;
}

export const useUpdateChatNotificationPreferences = (
  config: UseUpdateChatNotificationPreferencesConfig = {}
) => {
  const { onSuccess, onError } = config;

  const [updatePreferences, { loading }] =
    useUpdateChatNotificationPreferencesDataMutationMutation({
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    });

  const updateNotificationPreferences = useCallback(
    async (input: UpdateChatNotificationPreferencesInput) => {
      try {
        await updatePreferences({
          variables: {
            input: {
              id: input.chatId,
              newOrder: {
                deselectedUsersList: input.isEnabled ? [] : [input.supplierId],
              },
            },
          },
        });

        onSuccess?.();
      } catch (error) {
        const notificationError =
          error instanceof Error
            ? error
            : new Error('Failed to update notification preferences');
        onError?.(notificationError);
        throw notificationError;
      }
    },
    [updatePreferences, onSuccess, onError]
  );

  return {
    updateNotificationPreferences,
    isUpdating: loading,
  };
};
